import Vue from 'vue';
import Router from 'vue-router';

import {
    ACCOUNT,
    ACTIVITIES,
    ADD_CHILD,
    CALENDAR,
    CHILDREN,
    CONFIRM_REGISTRATION,
    EDIT_CHILD,
    ERRORS,
    LAYOUT,
    LOGIN,
    NOTIFICATIONS,
    PROFILE,
    RECEIPTS,
    SHOPPING_CART,
    CLASSES_WIDGET,
    CAMPS_WIDGET,
    AFTERCARE_WIDGET,
    ACTIVITIES_WIDGET,
    REGISTRATION_CHILDREN
} from '@/router/names';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/parents',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/:school/login',
            name: LOGIN,
            component: () => import('@/components/no-auth/Login'),
        },
        {
            path: '/:school/confirm-registration',
            name: CONFIRM_REGISTRATION,
            component: () => import('@/components/no-auth/ConfirmRegistration'),
        },
        {
            path: '/:school/public/activities',
            name: ACTIVITIES_WIDGET,
            component: () => import('@/components/dashboard/widgets/ActivitiesWidget')
        },
        {
            path: '/:school/public/classes',
            name: CLASSES_WIDGET,
            component: () => import('@/components/dashboard/widgets/ClassesWidget')
        },
        {
            path: '/:school/public/camps',
            name: CAMPS_WIDGET,
            component: () => import('@/components/dashboard/widgets/CampsWidget')
        },
        {
            path: '/:school/public/after-care',
            name: AFTERCARE_WIDGET,
            component: () => import('@/components/dashboard/widgets/AftercareWidget')
        },
        {
            path: '/:school/registration-children',
            name: REGISTRATION_CHILDREN,
            component: () => import(/* webpackChunkName: "children" */ '@/components/dashboard/FirstAddChildren')
        },
        {
            path: '/:school/',
            name: LAYOUT,
            component: () => import('@/components/dashboard/Dashboard'),
            redirect: '/:school/activities',
            children: [
                {
                    path: 'activities',
                    name: ACTIVITIES,
                    component: () => import(/* webpackChunkName: "activities" */ '@/components/dashboard/pages/Activities/Activities'),
                },
                {
                    path: 'children',
                    name: CHILDREN,
                    component: () => import(/* webpackChunkName: "children" */ '@/components/dashboard/pages/Children/Children'),
                },
                {
                    path: 'children/add-child',
                    name: ADD_CHILD,
                    component: () => import(/* webpackChunkName: "children" */ '@/components/dashboard/pages/Children/AddChild'),
                },
                {
                    path: 'children/edit-child',
                    name: EDIT_CHILD,
                    component: () => import(/* webpackChunkName: "children" */ '@/components/dashboard/pages/Children/EditChild'),
                },
                {
                    path: 'receipts',
                    name: RECEIPTS,
                    component: () => import(/* webpackChunkName: "receipts" */ "@/components/dashboard/pages/Receipts/Receipts"),
                },
                {
                    path: 'calendar',
                    name: CALENDAR,
                    component: () => import(/* webpackChunkName: "calendar" */ '@/components/dashboard/pages/Calendar/Calendar'),
                },
                {
                    path: 'account/',
                    name: ACCOUNT,
                    component: () => import(/* webpackChunkName: "account" */ '@/components/dashboard/pages/Profile/Account'),
                    children: [
                        {
                            path: 'profile',
                            name: PROFILE,
                            component: () => import(/* webpackChunkName: "account" */ '@/components/dashboard/pages/Profile/Profile'),
                        },
                        {
                            path: 'notifications',
                            name: NOTIFICATIONS,
                            component: () => import(/* webpackChunkName: "account" */ '@/components/dashboard/pages/Profile/Notifications'),
                        }
                    ]
                },
                {
                    path: 'shopping-cart',
                    name: SHOPPING_CART,
                    component: () => import(/* webpackChunkName: "shopping-cart" */ '@/components/dashboard/pages/ShoppingCart/ShoppingCart'),
                }
            ]
        },
        {
            path: '/:school/errors',
            name: ERRORS,
            component: () => import('@/components/no-auth/Errors'),
        }
    ]
});

export default router;

router.beforeEach((to, from, next) => {
    !to.matched.length
        ? next({ name: 'ERRORS', params: router.currentRoute.params, query: { exception: 'PAGE_NOT_FOUND' } })
        : next();
});


// WEBPACK FOOTER //
// ./src/router/router.js